import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskInput'
})
export class MaskInputPipe implements PipeTransform
{
  public transform(value: string, maskChar = '*'): string
  {
    const str = value.split('');
    const finalArr = [];
    const len = str.indexOf('@');

    // Email mask
    if (len > -1)
    {
      str.forEach((item, pos) =>
      {
        finalArr.push((pos >= 1 && pos <= len - 3 && str[pos] !== '.') ? maskChar : str[pos]);
      });
    }
    else
    // Phone mask
    {
      let numberCount = 0;
      str.forEach((item, pos) =>
      {
        if (Number(str[pos]))
        {
          finalArr.push((numberCount === 0 || numberCount >= 3) ? str[pos] : maskChar);
          if (numberCount >= 3)
          {
            numberCount = 0;
          }
          numberCount += 1;
        }
        else
        {
          finalArr.push((numberCount === 0 || numberCount >= 3 || str[pos] === '-') ? str[pos] : maskChar);
        }
      });
    }
    return finalArr.join('');
  }
}
